import React, { FC } from 'react';
import { SettingsLabel } from 'components/organisms/module-settings/styles';
import { SectionLayoutTypes } from './section-layout.types';

export const SectionLayout: FC<SectionLayoutTypes> = ({ children, title }) => {
  return (
    <div>
      <SettingsLabel>{title}</SettingsLabel>
      {children}
    </div>
  );
};
